// Base URL for the botpredictor service API.
export const SERVER = 'https://botpredictor.noe.casa';
// export const SERVER = 'http://192.168.1.150:23081';

// localStorage key remembering the user's currently selected group.
export const SELECTED_GROUP_KEY = 'selected_group';

// localStorage key caching slug -> display-name lookups from /league_name,
// so the sidebar/titles don't flicker on reload while names are refetched.
export const LEAGUE_NAMES_KEY = 'league_names';

// localStorage key remembering the user's chosen UI language ('en' | 'es').
// Absent until the user manually switches; otherwise the browser language wins.
export const LANGUAGE_KEY = 'language';
